exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".grade-buttons-sm-and-down[data-v-778251f9],.grade-buttons-sm-and-up[data-v-778251f9]{width:100%}.grade-buttons-sm-and-up .btn[data-v-778251f9]{width:20%}.grade-buttons-sm-and-up btn span[data-v-778251f9]{width:200px}.grade-buttons-sm-and-down .btn[data-v-778251f9]{width:20%}.grade-text[data-v-778251f9]{font-size:12px}.btn-grade[data-v-778251f9]{width:20%!important}.btn-grade .v-btn[data-v-778251f9]{width:100%!important}button.v-btn.v-btn--disabled.v-btn--active[data-v-778251f9]{color:green!important}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-778251f9","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/GradingButtons.vue
// module id = 596
// module chunks = 0